import { capitalOneTheme, THEME_CONSTANTS } from '@cof/plastic-components';
import merge from 'lodash.merge';

import * as cap1Components from './components';
import * as globalComponentOverrides from '../shared';
import globalStyles from './globalStyles';
import dOneLogoLight from '../../assets/images/D-One-Vector-light.svg';

const { COLORS } = THEME_CONSTANTS;

export default merge({}, capitalOneTheme, {
    components: { ...globalComponentOverrides, ...cap1Components },
    globalStyles,
    pages: {
        openBanking: {
            background: COLORS.capitalOne.blue750,
            textColor: 'global.white',
            headingColor: 'global.white',
            highlightColor: 'capitalOne.teal450',
            bulletColor: 'capitalOne.blue750',
            borderColor: 'global.grey300',
            iconBox: COLORS.global.white,
            iconColour: COLORS.capitalOne.pink250,
            paragraphVariant: 'light',
            subheadingFontWeight: '500',
            dOneLogo: dOneLogoLight,
            experimentIconColor: COLORS.capitalOne.blue750
        }
    }
});
